import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        count: 1,
        title: `أعمال الهياكل الخرسانية`,
        icon: require('./../../images/icon/crane-1.png'),
        description: 'أعمال الانشاءات الخرسانية والتي تشمل أعمال الأساسات والميدات ورقاب الأعمدة والجدران والأعمدة والبلاطات والطوب والحجر والسلالم وأنظمة السلامة',
    },
    {
        count: 2,
        title: 'أعمال التلييس والبلاط',
        icon: require('./../../images/icon/renovation.png'),
        description: 'خدمة أعمال البلاط تشمل تقديم تصاميم مميزة ومبتكرة تواكب الأحدث في عالم الديكور للمشاريع البنائية، وتضيف لمشروعك الجمال والإبداع',
    },
    {
        count: 3,
        title: 'أعمال الديكورات والدهانات',
        icon: require('./../../images/icon/toolbox.png'),
        description: 'من الخدمات في هذا المجال التصميم الداخلي للمساحات السكنية والتجارية، وتركيب الأرضيات والجدران والأسقف وتركيب الديكورات والأثاث والإضاءة، وتنظيف وصيانة المساحات ونحن تستخدم مواد عالية الجودة نحن نعمل بشكل احترافي ومتميز ليليق بعميلنا',
    },
    {
        count: 4,
        title: 'توريد وتركيب جميع أنواع الأبواب والنوافذ',
        icon: require('./../../images/icon/compass.png'),
        description: 'يشمل توريد وتركيب الأبواب والنوافذ بمختلف أنواعها مثل الأبواب الخشبية والمعدنية والزجاجية وابواب ونوافذ الالمونيوم pvc  ذات جودة متميزة ومحكمة الاغلاق وتوفر العزل الصوتي والحراري ومانعة للتسرب ',
    } ,
    {
        count: 5,
        title: 'أعمال الالكتروميكنيكال والأنظمة الأمنية وأنظمة السلامة',
        icon: require('./../../images/icon/compass.png'),
        description: 'وتشمل الأعمال الميكانيكية والكهربائية والصحية والأعمال الهندسية والتصاميم والتركيب وأنظمة تشغيل أجهزة التدفئة والتهوية وتكييف الهواء والتركيبات الصحية كافة الأعمال الكهربائية وأنظمة الامن والسلامة ونظم مكافحة الحرائق ',
    }
]

var img1 = require('./../../images/background/bg-6.png');

class OurServices extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding  p-b50  square_shape2">
                    <div className="section-content">
                        <div className="Service-half-top p-t80  bg-dark bg-moving" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                            <div className="container">
                                {/* TITLE START */}
                                <div className="section-head text-white">
                                    <div className="mt-separator-outer separator-left">
                                        <div className="mt-separator">
                                            <h2 className="text-white text-uppercase sep-line-one " style={{ fontFamily: 'Cairo, sans-serif', fontSize: '40px', fontWeight: 'bold' }}><span className="font-weight-300 text-primary"></span> خدماتنا</h2>
                                        </div>
                                    </div>
                                    <h3 style={{ fontFamily: 'Cairo, sans-serif', fontSize: '24px', fontWeight: 'light' , textAlign : 'right'}}>نقدم في شركتنا مجموعة متنوعة من خدمات البناء، تشمل التصميم، التنفيذ، الترميم، والإشراف على المشاريع، مع الالتزام بالجودة والدقة في كل مرحلة من مراحل العمل.
                                    </h3>
                                </div>
                                {/* TITLE END */}
                            </div>
                        </div>
                        <div className="services-half-bottom">
                            <div className="container">
                                <div className="row">
                                    {services.map((item, index) => (
                                        <div  key={index}>
                                            <div className="mt-icon-box-wraper m-b30">
                                                <div className="relative icon-count-2 bg-gray p-a30 p-tb50">
                                                    <span className="icon-count-number">{item.count}</span>
                                                    <div className="icon-md inline-icon m-b15 text-primary scale-in-center">
                                                        <span className="icon-cell"><img src={item.icon} alt=""/></span>
                                                    </div>
                                                    <div className="icon-content">
                                                        <h4 className=" m-b25" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '20px', fontWeight: 'bold' , textAlign : 'right'}}>{item.title}</h4>
                                                        <p style={{ fontFamily: 'Cairo, sans-serif', fontSize: '16px', fontWeight: 'light' , textAlign : 'right'}}>{item.description}</p>
                                                        <NavLink to={"/services"} className="site-button-link" data-hover="Read More" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '16px', fontWeight: 'light' , textAlign : 'right'}}>إقرأ المزيد <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
            </>
        );
    }
};

export default OurServices;